import { BrowserModule }  from '@angular/platform-browser';
import { NgModule }       from '@angular/core';
import { FormsModule }    from '@angular/forms';
import { RouterModule }   from '@angular/router';
import { HttpModule }     from '@angular/http';
import { NgbModule }      from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MdButtonModule, MdCardModule, MdMenuModule, MdToolbarModule, MdIconModule } from '@angular/material';
import { ResponsiveModule } from 'ng2-responsive';
import { Ng2PageScrollModule } from 'ng2-page-scroll';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { AgmCoreModule } from '@agm/core';
import { TruncatePipe } from './truncate.pipe';

import { AppComponent } from './app.component';
import { NavigationComponent }  from './navigation.component';
import { TopDetailsComponent }  from './top-details.component';
import { TopGalleryComponent }  from './top-gallery.component';
import { DescriptionComponent }  from './description.component';
import { MenuComponent }  from './menu.component';
import { BookComponent } from './book.component';
import { EventsComponent } from './events.component';
import { ReviewsComponent } from './reviews.component';
import { ContactUsComponent } from './contact-us.component';
import { HomeComponent }  from './home.component';
import { EventBookComponent }  from './event-book.component';
import { BooknowComponent }  from './book-now.component';
import { ReviewListComponent }  from './review-list.component';
import { MenuListComponent }  from './menu-list.component';
import { BottomGalleryComponent } from './bottom-gallery.component';
import { TimetableLocationComponent } from './timetable-location.component'
import { FooterComponent } from './footer.component';
import { PromotionComponent } from './promotion/promotion.component';
import { PromotionPageComponent } from './promotion-page/promotion-page.component';
import { RestaurantService }    from './restaurant.service';
import { MessageService }     from './message.service';
import { AppRoutingModule }     from './app-routing.module';


@NgModule({
  declarations: [
    TruncatePipe,
    AppComponent,
    NavigationComponent,
    TopDetailsComponent,
    TopGalleryComponent,
    DescriptionComponent,
    MenuComponent,
    HomeComponent,
    EventBookComponent,
    ReviewListComponent,
    MenuListComponent,
    BookComponent,
    BooknowComponent,
    EventsComponent,
    ReviewsComponent,
    ContactUsComponent,
    BottomGalleryComponent,
    TimetableLocationComponent,
    FooterComponent,
    PromotionComponent,
    PromotionPageComponent,
   ],

  imports: [
    BrowserModule,
    ResponsiveModule,
    FormsModule,
    AppRoutingModule,
    HttpModule,
    BrowserAnimationsModule,
    MdButtonModule,
    MdMenuModule,
    MdCardModule,
    MdToolbarModule,
    MdIconModule,
    Ng2PageScrollModule,
    Ng2DeviceDetectorModule.forRoot(),
    NgbModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDzh54-5-fGrGsdfO0DZcqv5E4P_qs_Nu0'
    })
  ],
  
  providers: [
    RestaurantService,
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/app.module.ts